export default "__VITE_ASSET__Cs7j4JLm__"